{
  "completed": "Fullført: ",
  "current": "Nåværende: ",
  "notCompleted": "Ikke fullført: ",
  "steplist": "Trinnliste"
}
